export default __webpack_public_path__ + "static/media/logos_python.8af9c25a.svg";